import dayjs from 'dayjs'
import { makeDateSeries } from '@local_modules/generic/dates/make-date-series/index.js'
import { activateOptionSelector } from '../../../../modules/option-selector/index.js'

export function showSelectors (changeAction, context) {
  console.log('showSelectors', context)

  const optionSelectorShow = [
    'dates'
  ]

  const dateSeriesStart = context.specificOrgId ? dayjs().subtract(48, 'months').format('YYYY-MM-DD') : context.browserAppAccount?.data?.firstLedgerDate
  const dateseries = makeDateSeries(dateSeriesStart)

  const currenciesForAccount = context.currenciesForAccount

  const optionSelectorParams = activateOptionSelector({
    containerId: 'optionSelector',
    show: optionSelectorShow,
    hide: [],
    default: 'organisations',
    onChange: changeAction,
    dateseries,
    dateOptions: {
      default: {
        from: 'relative:-2',
        to: 'relative:0'
      }
    },
    customSettings: {
      organisations: mapOrganisations(context),
      orgOptions: {
        allowConso: true,
        allowMultiple: false
        // defaultIndex: 0
      },
      currencies: currenciesForAccount
    }
  })
  return optionSelectorParams
}

function mapOrganisations (context) {
  if (context.specificOrgId) return forNoAccount(context)

  return context.browserAppAccount?.data?.entities
}

/** Allowing the page to be loaded for a specific entity, without a specific account */
function forNoAccount (context) {
  return [{
    _id: context.specificOrgId,
    name: context.specificOrgId
  }]
}
